import React, { useRef, useState, useCallback, useEffect } from 'react'

//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import AnimationWrap from 'components/common/AnimationWrap'

//* Style
import FollowersSectionStyle from './style'

//* Gsap functions
import { slideDown } from 'helpers/_gsapFunctions'
import { withUIContext } from 'context'

const FollowersSection = ({ socials, winWidth }) => {
	//! States
	const [secObj, setSecObj] = useState()

	//! Refs
	const items = useRef([])
	const iconRef = useRef([])
	const firstItemRef = useRef([])
	const secondItemRef = useRef([])
	const thirdItemRef = useRef([])

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, winWidth])

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! slideDown(item, stagger, delay)
			slideDown([firstItemRef.current, secondItemRef.current, thirdItemRef.current], 0.3)
		}
	}, [])

	return (
		<FollowersSectionStyle>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
				<div ref={items}>
					<div className='heightFitContent overflowHidden'>
						<a ref={firstItemRef} href={socials.youtube.link} target='_blank' className='FlexBox alignMiddle linkWrap'>
							<Text
								tag='h1'
								className='terminaBold followCount'
								text={socials.youtube.followers}
								rel='noopener noreferrer'
								aria-label='youtube link'
							/>
							<Text tag='h1' className='terminaBold linkText' text={'YouTube'} />
							<svg className='icon-youtube' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 118.95 97.79' ref={iconRef}>
								<g id='Layer_2' data-name='Layer 2'>
									<g id='Layer_1-2' data-name='Layer 1'>
										<path d='M114.61,37.87c-.82-2.56-1.66-5.22-2.36-7.86-.37-1.35-.71-2.76-1.07-4.2-2.33-9.45-5-20.15-13.67-24.2C92.14-.88,85.14.05,79,.87a1.5,1.5,0,0,0,.39,3c5.78-.77,12.32-1.64,16.89.49,7.4,3.43,9.86,13.4,12,22.19.36,1.46.71,2.89,1.08,4.25.72,2.71,1.57,5.4,2.4,8,2.26,7.16,4.4,13.92,4.19,21.17-.12,3.89-.25,8.3-2.26,11.76-3,5.14-14.63,8.57-19.61,10A422.25,422.25,0,0,1,39.16,94c-7.58,1.16-15.31,1.65-20.54-2.62a17.17,17.17,0,0,1-5.68-8.09A290.29,290.29,0,0,1,4.86,49.1c-.49-2.59-1-5.33-1.6-8.3-1.35-6.83,3-14.15,7.89-18.38A31.63,31.63,0,0,1,21.5,17C38.3,11.25,66.4,6.4,71,5.71a1.44,1.44,0,0,0,.46,0,1.67,1.67,0,0,0,1.51-1.14,1.49,1.49,0,0,0-.4-1.5c-.62-.59-.62-.59-6.62.45C63,4,58.44,4.83,52.86,6c-9.36,1.9-22.57,4.87-32.34,8.23a34,34,0,0,0-11.32,6C4.05,24.59-1.37,32.81.31,41.38c.59,3,1.11,5.7,1.6,8.29a297.34,297.34,0,0,0,8.17,34.5,20.13,20.13,0,0,0,6.66,9.52c3.8,3.11,8.52,4.1,13.53,4.1A62.33,62.33,0,0,0,39.61,97,426.76,426.76,0,0,0,94.92,84.62c5.77-1.7,17.78-5.23,21.36-11.4,2.39-4.13,2.54-9.15,2.66-13.18C119.17,52.28,116.85,45,114.61,37.87Z' />
										<path d='M46.07,35.15a1.86,1.86,0,0,0-.56,1.71l5.1,27a1.94,1.94,0,0,0,1.11,1.42,2,2,0,0,0,1.8-.07L77.39,51.65a6.31,6.31,0,0,0,3.2-3.2,3.9,3.9,0,0,0-.28-3.2C79,42.8,75.54,41.76,74.52,41.5l-26.7-6.8A1.88,1.88,0,0,0,46.07,35.15Zm27.71,9.26c1.82.46,3.42,1.39,3.89,2.27a.93.93,0,0,1,.08.81c-.2.59-1,1.09-1.84,1.55L53.29,61.88,48.79,38Z' />
									</g>
								</g>
							</svg>
						</a>
					</div>
					<div className='heightFitContent overflowHidden'>
						<a
							ref={secondItemRef}
							href={socials.facebook.link}
							target='_blank'
							className='FlexBox alignMiddle linkWrap'
							rel='noopener noreferrer'
							aria-label='facebook link'
						>
							<Text tag='h1' className='terminaBold followCount' text={socials.facebook.followers} />
							<Text tag='h1' className='terminaBold linkText' text={'Facebook'} />
							<svg className='icon-facebook' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68.78 116.78' ref={iconRef}>
								<g id='Layer_2' data-name='Layer 2'>
									<g id='Layer_1-2' data-name='Layer 1'>
										<g id='Group_44676' data-name='Group 44676'>
											<g id='Path_55602' data-name='Path 55602'>
												<path d='M44.08,116.78a2.7,2.7,0,0,1-1.26-.31,2.76,2.76,0,0,1-1.47-2C39.26,103.38,34,92.32,29,81.62Q27.88,79.31,26.82,77A59,59,0,0,1,13.18,83c-1.4.47-2.81.93-4.24,1.46a2.19,2.19,0,0,1-2.71-1.11A54.62,54.62,0,0,1,3.3,75.44,30.53,30.53,0,0,0,.36,68.2a2.57,2.57,0,0,1,1.17-3.66l11.21-5c-5.5-11-6.17-22.51-1.84-32.5C15,17.65,24.7,9.32,39,3c1.82-.8,3.94-1.66,6.16-2.46L46.51,0l.55,1.33c1.21,2.92,2.15,5.72,3.07,8.44,1.1,3.26,2.15,6.35,3.61,9.66a2.23,2.23,0,0,1-.06,2,2.27,2.27,0,0,1-1.57,1.19C43.4,24.32,38.6,26.2,36.53,31.65c-2.21,5.8-.75,11.69,1.2,17.28L59.3,40.06A2.78,2.78,0,0,1,63,41.77a36.6,36.6,0,0,0,2.39,5.94,16.39,16.39,0,0,0,1.44,2c1.11,1.44,2.26,2.93,1.88,4.63A4.06,4.06,0,0,1,66.3,57c-1.94,1-5.27,2.54-8.81,4.2-3.33,1.57-6.77,3.19-9.06,4.32C51.14,72.06,53.6,79.23,56,86.17c2.25,6.54,4.57,13.32,7.15,19.72a2.78,2.78,0,0,1-.07,2.21,2.73,2.73,0,0,1-1.65,1.45,135.6,135.6,0,0,0-14.82,6.33l-1.34.63A2.67,2.67,0,0,1,44.08,116.78Zm-16-44.18.74,1.61c.93,2,1.9,4.06,2.88,6.13,5.09,10.78,10.37,21.93,12.56,33.33l1.06-.5a140.85,140.85,0,0,1,14.94-6.4c-2.57-6.4-4.87-13.13-7.11-19.63-2.64-7.69-5.13-15-8-21.75l-.55-1.29,1.25-.63c2.18-1.11,6.35-3.08,10.38-5,3.52-1.66,6.84-3.23,8.75-4.18.72-.35.82-.59.82-.59,0-.35-.81-1.46-1.33-2.12a19.88,19.88,0,0,1-1.64-2.38,33.78,33.78,0,0,1-2.59-6.29L36,52.9l-.53-1.47C33.16,45.16,31,37.85,33.72,30.59S43,21.4,50.64,19.82c-1.34-3.14-2.36-6.16-3.35-9.09-.76-2.24-1.54-4.55-2.46-6.91-1.66.63-3.23,1.27-4.61,1.89-13.61,6-22.8,13.83-26.57,22.53-5.58,12.9-.85,25.16,2.48,31.32L16.89,61,3.18,67.09a34,34,0,0,1,3,7.47,52,52,0,0,0,2.46,6.79c1.22-.43,2.43-.84,3.61-1.23C17,78.54,21.53,77,26.61,73.59Z' />
											</g>
										</g>
									</g>
								</g>
							</svg>
						</a>
					</div>
					<div className='heightFitContent overflowHidden'>
						<a
							ref={thirdItemRef}
							href={socials.instagram.link}
							target='_blank'
							className='FlexBox alignMiddle linkWrap'
							rel='noopener noreferrer'
							aria-label='instagram link'
						>
							<Text tag='h1' className='terminaBold followCount' text={socials.instagram.followers} />
							<Text tag='h1' className='terminaBold linkText' text={'Instagram'} />
							<svg className='icon-instagram' xmlns='http://www.w3.org/2000/svg' ref={iconRef} viewBox='0 0 112.08 109.46'>
								<g id='Layer_2' data-name='Layer 2'>
									<g id='Layer_1-2' data-name='Layer 1'>
										<path d='M112,69.59c-.36-8.79-3-17.23-5.62-25.38-.94-3-1.92-6.06-2.77-9.13-.44-1.56-.86-3.19-1.3-4.86C99.42,19.4,96.21,7.14,88,2.24,82.74-.86,76.27-.06,70.56.65a1.51,1.51,0,0,0-1.3,1.68,1.48,1.48,0,0,0,1.67,1.3C76.16,3,82.09,2.24,86.42,4.82,93.62,9.09,96.67,20.72,99.36,31c.44,1.68.87,3.33,1.31,4.91.87,3.11,1.85,6.22,2.8,9.23,2.65,8.33,5.14,16.2,5.49,24.6.18,4.5.39,9.6-1.24,13.56C105.37,89,94.93,92.45,90.48,93.93a303.54,303.54,0,0,1-49.84,11.91c-6.85,1-13.89,1.29-19-3.77a23.8,23.8,0,0,1-6-9.73c-5-16.33-7.1-26-10-39.49-.65-3-1.34-6.17-2.11-9.61-1.78-8,1.7-16.36,5.94-21a23.7,23.7,0,0,1,9.05-5.71c15.26-6,40.47-10.42,44.76-11a1.46,1.46,0,0,0,.51,0,1.69,1.69,0,0,0,1.48-1.17,1.53,1.53,0,0,0-.45-1.51c-.63-.56-.64-.56-6.14.42-2.63.46-6.82,1.24-11.9,2.32-8.53,1.82-20.55,4.73-29.36,8.21A26.46,26.46,0,0,0,7.21,20.19c-4.41,4.87-8.8,14-6.64,23.7.76,3.44,1.45,6.6,2.1,9.6,2.83,13,5.07,23.27,10.09,39.74a26.88,26.88,0,0,0,6.76,11c4.09,4,9,5.26,14.14,5.26a50.49,50.49,0,0,0,7.43-.65,306.21,306.21,0,0,0,50.33-12c5.26-1.74,16.2-5.36,19.08-12.36C112.37,79.85,112.15,74.4,112,69.59Z' />
										<path d='M58.63,33.9l-.23,0C51,35.31,39.07,40.39,36,46.33s-1.79,12.07-.15,18.4c1,3.78,5,8.87,8.54,10.89C49.56,78.52,54.52,80,59.19,80h.71c11.46-.37,21.58-11.14,21.23-22.6C80.81,46.61,71,33.9,59.1,33.9Zm19.5,23.57c.3,9.89-8.43,19.19-18.32,19.51-4.34.15-9-1.2-13.91-4-2.88-1.63-6.34-6-7.12-9-1.54-6-2.61-11.32-.08-16.28,2.23-4.37,12.61-9.37,20.12-10.8h.27C69.05,36.9,77.85,48.09,78.13,57.47Z' />
										<path d='M73.34,20.94a5.63,5.63,0,0,0-1,3.2,5.86,5.86,0,0,0,.67,2.5c1,1.62,3.63,2.29,5.36,1.92A10.81,10.81,0,0,0,80.21,28c1.39-.57,2.56-2.9,2.67-3.64a5.23,5.23,0,0,0-1.28-4.2c-1.13-1.1-1.86-1.9-5.25-1.34h0A4.41,4.41,0,0,0,73.34,20.94Z' />
									</g>
								</g>
							</svg>
						</a>
					</div>
				</div>
			</AnimationWrap>
		</FollowersSectionStyle>
	)
}

export default withUIContext(FollowersSection, ['winWidth'])
